import './styles/ThreeDotsLoader.css'

export default function ThreeDotsLoader() {
	return (
		<div className="py-2 px-5 bg-gray-200 rounded-2xl w-fit">
			<div className="dot-collision" />
		</div>
	)
}
